import { useQuery } from 'react-query';
import { TOrders, TPortfolio } from '@dekafvv/sharedfrontend';
import { getAllPortfolios, getContactPortfolioOrderbook } from './requests';

export const useGetAllPortfolios = ({
    contactId,
    language = 'en',
    refetchOnMount = true,
    enabled = true,
    onSuccess,
    onError,
}: {
    contactId: number;
    refetchOnMount?: boolean,
    language?: string,
    enabled?: boolean
    onSuccess?: (resp: any) => void,
    onError?: (err?: any) => void,
}) => {
    const query = useQuery<
        TPortfolio[],
        null | { message: string },
        TPortfolio[]
    >({
        queryFn: () => getAllPortfolios({ contactId, language }).then(({ data }) => data),
        queryKey: [
            'getAllPortfolios',
            contactId,
            language,
        ],
        refetchOnWindowFocus: false,
        refetchOnMount,
        enabled,
        onSuccess: (resp) => {
            if (onSuccess) {
                onSuccess(resp);
            }
        },
        onError: (err?: any) => {
            if (onError) {
                onError(err);
            }
        },
    });

    return query;
};

export const useGetContactPortfolioOrderbook = ({
    clientId,
    portfolioId,
    refetchOnMount = true,
    enabled = true,
    onSuccess,
    onError,
}: {
    clientId: string;
    refetchOnMount?: boolean,
    portfolioId: string,
    enabled?: boolean
    onSuccess?: (resp: any) => void,
    onError?: () => void,
}) => {
    const query = useQuery<
        TOrders,
        null | { message: string },
        TOrders
    >({
        queryFn: () => getContactPortfolioOrderbook(
            { clientId, portfolioId },
        ).then(({ data }) => data),
        queryKey: ['getContactPortfolioOrderbook', clientId, portfolioId],
        refetchOnWindowFocus: false,
        refetchOnMount,
        enabled,
        onSuccess: (resp) => {
            if (onSuccess) {
                onSuccess(resp);
            }
        },
        onError: () => {
            if (onError) {
                onError();
            }
        },
    });

    return query;
};
